// extracted by mini-css-extract-plugin
export default {"listTitle":"ListTitle_listTitle__p+b9r"};